<script>
export default {
  name: 'TextFormatterIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24,
    },
    color: {
      type: String,
      default: '#8E8E8E',
    },
  },
}
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    enable-background="new 0 0 24 24"
    :height="size"
    viewBox="0 -1 24 24"
    :width="size"
  >
    <path fill="none" d="M0 0h24v24H0z" />
    <path
      :fill="color"
      d="M5 17v2h14v-2zm4.79-4.81h4.44l.98 2.81h1.9L12.98 4h-1.97L6.88 15h1.9zm2.16-6.15h.09l1.6 4.55h-3.29z"
    />
  </svg>
</template>